/**
 * Reusable brand logo — official SocialCog Training® image.
 * Size variants: sm (h-8), md (h-10), lg (h-14), xl (h-24).
 */
export function Logo({ size = "md", className = "", inverse = false, testid = "brand-logo" }) {
  const heights = {
    sm: "h-8",
    md: "h-10",
    lg: "h-14",
    xl: "h-24",
  };
  return (
    <img
      src="/brand/socialcog-logo.png"
      alt="SocialCog Training®"
      data-testid={testid}
      className={`${heights[size] || heights.md} w-auto object-contain select-none ${inverse ? "brightness-0 invert" : ""} ${className}`}
      draggable={false}
    />
  );
}
